const PickListRubrics = (state = { rubricType : [], rubricCondition : []}, action) => {
    switch (action.type) {
        case 'GET_RUBRIC_TYPE':
            
            return state;
        case 'SET_RUBRIC_TYPE'  :
            
            state.rubricType = action.payload;
            return state;
        case 'GET_RUBRIC_CONDITION'  :
            // state.rubricCondition = action.payload;
            return state;
        case 'SET_RUBRIC_CONDITION'  :
            state.rubricCondition = action.payload;
            return state;
        default:
            return state;
    }
};
export default PickListRubrics;







